import React, { useState } from 'react';
import styles from '../styles';

const DoubleChevron = ({ color = '#64748B' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 17L11 12L6 7" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13 17L18 12L13 7" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CtaButton = ({ text, onClick, light = false, style: customStyle = {}, type = 'button' }) => {
  const [hovered, setHovered] = useState(false);

  const defaultColor = light ? 'rgba(255,255,255,0.4)' : '#64748B';
  const hoverColor = light ? '#F3F4F6' : '#1B2B3E';

  return (
    <button
      type={type}
      style={{
        ...styles.ctaGroup,
        border: 'none',
        background: 'none',
        padding: 0,
        ...customStyle,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <span style={light ? styles.ctaTextLight : styles.ctaText}>{text}</span>
      <div style={{ ...styles.ctaIcon, ...(hovered ? styles.ctaIconHover : {}) }}>
        <DoubleChevron color={hovered ? hoverColor : defaultColor} />
      </div>
    </button>
  );
};

export default CtaButton;
